module.exports = __webpack_public_path__ + "static/img/silhouette_05.14f28b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_05.png
// module id = 7TWt
// module chunks = 0